<template>
    <form ref="form">
        <b-form-group>
            <b-row>
                <b-col sm="4"> <label> Protokol Adı </label> </b-col>
                <b-col sm="8"> <b-form-input v-model="name" placeholder="Protokol Adı" /></b-col>
            </b-row>
        </b-form-group>
    </form>
</template>

<script>
    import i18n from '@/plugins/i18n';

    export default {
        name: "ReceiverProtocol",
        props:{
            data: Object,
            modalName: String,
            modalEvent: Function,
            save: Boolean,
            saveState: Function
        },
        data: function(){
            return {
                name: this.data ? this.data.name : ""
            }
        },
         watch:{
            save: async function(data){
                if(data){
                    let val = {
                        name: this.name,
                        "is_protocol": true
                    }
                    
                    switch(this.modalName){
                        case "add":
                            await this.$store.dispatch('addRecProtocol', val)
                            break;  
                        case "edit":
                            val.id = this.data.id
                            await this.$store.dispatch('editRecProtocol', val)
                            break;  
                    }
                    if(this.$store.getters.getStatus.status == "Success"){
                        this.$store.dispatch('listRecProtocols')
                        this.clearForm()
                    }
                }
                this.saveState(false)
            },
            data: function (val){
                this.name = val.name
            }
        },
     
        methods:{
             clearForm(){
                this.name = ""
                this.modalEvent(false)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/ReceiverProtocol.vue